import { type I18n, LocaleProvider, useLocale } from '@iris/i18n/react';
import { AuthProvider } from '@iris/ui/auth/auth-provider';
import { Toaster } from '@iris/ui/components/ui/sonner';
import { UiProvider } from '@iris/ui/components/ui-provider';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { apiClient, authBridge } from './api';
import { queryClient } from './query';
import { router } from './router';

function Providers() {
  const { dir } = useLocale();
  return (
    <UiProvider dir={dir}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider
          app="OPS"
          client={apiClient}
          bridge={authBridge}
          onSignedOut={() => queryClient.clear()}
        >
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
      <Toaster position="top-center" dir={dir} />
    </UiProvider>
  );
}

export function App({ i18n }: { i18n: I18n }) {
  return (
    <LocaleProvider i18n={i18n}>
      <Providers />
    </LocaleProvider>
  );
}
